export const decodeURIAndTrim = (jsonString: string) =>
  decodeURIComponent(jsonString).trim();
